import { React, useEffect, useState } from 'react';
import { Button } from 'antd-mobile';
import { Card, Space } from 'antd';
import { WebviewHttpHandler } from 'shared/webviewHttpHandler';
import { HttpHandler } from 'shared/httpHandler';
import { useNavigate } from 'react-router-dom';
import liff from '@line/liff';
import secureStorage from 'shared/secureStorage';


const webviewHttpHandler = new WebviewHttpHandler(true);
const chatbotHttpHandler = new HttpHandler(true, process.env.REACT_APP_CHAT_BOT_URL);
const lineUserId = secureStorage.getItem('lineUserId');


const BusinessCard = () => {
  let navigate = useNavigate();
  const [staffData, setStaffData] = useState();
  const GetStaffData = async () => {
    await webviewHttpHandler.get(`/service/member/business-card?line=${lineUserId}`).then(
      (response) => {
        if (response.success === true && response.data !== null && response.data !== undefined) {
          setStaffData(response.data)
        } else {
          window.antdNotify('錯誤', response.message, 'fail')
        }
      }
    ).catch((error) => {
      navigate('/error500m');
    });
  }

  useEffect(() => {
    GetStaffData();
  }, []);

  const handleShareButtonClick = async () => {
    // var businessCard

    const businessCard = await chatbotHttpHandler.post(`/business_card/get_business_card_by_id?user_id=${lineUserId}`).then(
      (response) => {
        if (response.success) {
          return response.data
        } else {
          window.antdNotify('錯誤', "電子名片獲取失敗", 'fail')
        }
      }
    ).catch((error) => {
      navigate('/error500m');
    });

    liff.shareTargetPicker([
      {
        "type": "flex",
        "altText": "電子名片",
        "contents": businessCard,
      }])
      .then(function (targets) {
        // Handle the selected targets
        console.log(targets);
      }).catch((error) => {
        console.log(`shareTargetPicker error : `, error)
        window.antdNotify('錯誤', "電子名片發送失敗", 'fail')
      });
  }


  const cardTitle = (
    <div className="card-title-custom">
      <img
        className="mt-4"
        src="/images/logo/easyrent-full-name.svg"
        alt="Logo"
        style={{ width: 256 }}
      />
      <div className="">
        {staffData && staffData.name ? (<div className="subheading font-bold mb-2">{staffData.name}</div>) : (<div className="subheading font-bold mb-2">Staff Name</div>)}
        {staffData && staffData.name ? (<div className="text-bodt font-semibold grey mb-4">{staffData.title}</div>) : (<div className="text-bodt font-semibold grey mb-4">Staff Title</div>)}
      </div>
    </div>
  );

  return (
    <div className="main-container">
      <div className="business-card-container">
        <div className="heading font-bold">名片預覽</div>
        <div className="business-card">
          <Card title={cardTitle} bordered={false} style={{ width: 343 }}>
            <Space direction="vertical" size={2}>
              <Space>
                <div>信箱：</div>
                {staffData && staffData.mail ? (
                  <div className="ellipsis">{staffData.mail}</div>
                ) : (
                  <div className="ellipsis">Staff Email</div>
                )}
              </Space>
              <Space>
                <div>電話：</div>
                {staffData && staffData.tel ? (
                  <div className="ellipsis">{staffData.tel}</div>
                ) : (
                  <div className="ellipsis">Staff Phone</div>
                )}
              </Space>
              <Space>
                <div>官網：</div>
                {staffData && staffData.url ? (
                  <div className="ellipsis">{staffData.url}</div>
                ) : (
                  <div className="ellipsis">Staff Link</div>
                )}
              </Space>
            </Space>
          </Card>
        </div>
        <div className="mt-4">
          <Button className="line-button" onClick={handleShareButtonClick}>傳送給 LINE 好友</Button>
          <div className="text-sm font-normal mt-2">
            將名片分享給 LINE 好友們吧！
          </div>
        </div>
      </div>
    </div>
  );
};
export default BusinessCard;
